import { bankServices } from "../../config/axios";
import {
    GETUSERDETAILLIST_SUCCESS,
    GETUSERDETAILLIST_FAILED,
    RESET_GETUSERDETAILLIST,
    LOADING_GETUSERDETAILLIST,
    GETUSERDETAILLIST_NETWORKERROR,
} from '../types/index';

const resetgetUserManagementList = () => {
    return { type: RESET_GETUSERDETAILLIST };
};

const getUserManagementList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETUSERDETAILLIST });
    await bankServices
        .post("userdetails", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(success(res.data));
                    break;
                default:
                    dispatch(failed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: GETUSERDETAILLIST_NETWORKERROR,
                payload: err
            });
        });
}

function success(data) {
    return {
        type: GETUSERDETAILLIST_SUCCESS,
        payload: data
    };
}
function failed(data) {
    return {
        type: GETUSERDETAILLIST_FAILED,
        payload: data
    };
}

export { resetgetUserManagementList, getUserManagementList }